import styled from "styled-components";

export const IntegrationsContainer = styled.div`
  margin-top: 54px;
  h1 {
    text-align: center;
  }
`;

export const IframeContainer = styled.div`
  iframe {
    margin-top: 54px;
    background: transparent;
    border: 1px solid #ccc;
    width: 100%;
    height: ${(props) => props.height}px;
  }
  p {
    margin: 40px 0 0 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  button {
    margin-right: 15px;
  }
`;

export const IconButton = styled.button`
  display: flex
  align-items: center;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  outline: none;
  padding: 0 16px;
  position: relative;
  font-weight: 600;
  line-height: 1;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  height: ${(props) => props.height}px;
  background-color: #4C76E0;
  color: white;

  &:hover, &:focus {
    background-color: #2353cc;
  }

  &:active {
    background-color: #1a3e97;
  }
`;
